import React, { useState } from "react";
import "./Notification.css";

const Notification = ({ message, type }) => {
    if (!message) return null;

    return (
        <div className={`notification ${type}`}>
            <p>{message}</p>
        </div>
    );
};

export const useNotification = () => {
    const [notification, setNotification] = useState({ message: "", type: "" });

    const showNotification = (message, type = "success") => {
        setNotification({ message, type });
        setTimeout(() => {
            setNotification({ message: "", type: "" });
        }, 3000); // Auto-dismiss after 3 seconds
    };

    return [notification, showNotification];
};

export default Notification;
